class NotFoundPage extends React.Component {

    render() {
        return (
            <div>
                <div className="app-error-page">
                    <div className="error-code-text">Not found page</div>
                </div>
            </div>
        );
    }
}


export default NotFoundPage;



// WEBPACK FOOTER //
// ./app/components/pages/service/notFound/NotFound.page.jsx